import { selectCurrentMerchant } from 'selectors/merchant'

export function selectUserIsAuthenticated(state) {
  return (
    state.auth.current_merchant_user_id !== null &&
    !!selectCurrentMerchant(state).id &&
    state.auth.token !== null
  )
}
